import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { PositionStyle } from "@insite/mobius/Popover";
import { InputStyle, TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ArrowRightWhiteIcon from "@tCentro/Icons/ArrowRightWhiteIcon";
import { useGetLink } from "@tCentro/Store/CustomLinksSelectors";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    bannerImage = "bannerImage",
    bannerTitle = "bannerTitle",
    bannerLoginbtnLabel = "bannerLoginbtnLabel",
    bannerCreateAccountbtnLabel = "bannerCreateAccountbtnLabel",
    bannerLoginbtnLink = "bannerLoginbtnLink",
    bannerCreateAccountbtnLink = "bannerCreateAccountbtnLink",
    loginTitle = "loginTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.bannerImage]: string;
        [fields.bannerTitle]: string;
        [fields.bannerLoginbtnLabel]: string;
        [fields.bannerCreateAccountbtnLabel]: string;
        [fields.bannerLoginbtnLink]: LinkFieldValue;
        [fields.bannerCreateAccountbtnLink]: LinkFieldValue;
        [fields.loginTitle]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CENNewHomePageBannerStyles {
    bannerContainer: InjectableCss;
    mainTitleStyles?: InjectableCss;
    mainUserNameTitleStyles?: InjectableCss;
    searchbarStyles?: TextFieldPresentationProps;
    buttonMainContainer?: InjectableCss;
    // loginStyles?: InjectableCss;
    // createAccountStyles?: InjectableCss;
    btnstyles?: InjectableCss;
    imageStyles?: InjectableCss;
    btnChildContainer?: InjectableCss;
    bannerContentContainer: InjectableCss;
    mainBannerBackgroundContainer?: InjectableCss;
    loggedOutTitleStyles?: InjectableCss;
    rightImgDiv?: InjectableCss;
}

export const cenNewHomepageBannerStyles: CENNewHomePageBannerStyles = {
    mainBannerBackgroundContainer: {
        css: css`
            background: linear-gradient(90deg, #266b40 44.06%, #2d804c 71.87%, #43687a 100%);
            margin-top: 40px;
        `,
    },
    bannerContainer: {
        css: css`
            max-width: 1800px;
            margin: auto;
            width: 100%;
            display: flex;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        align-items: center;
                        padding: 80px 20px 0px 20px;
                        gap: 20px;
                    `,
                    css`
                        flex-direction: column;
                        align-items: center;
                        padding: 80px 40px 0px 40px;
                        gap: 20px;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    bannerContentContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 80px 0px 80px 50px;
            flex-wrap: wrap;
            width: 58.33%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        padding: 0px;
                        box-sizing: border-box;
                        align-items: center;
                    `,
                    css`
                        width: 100%;
                        padding: 0px;
                        box-sizing: border-box;
                        align-items: center;
                    `,
                    css`
                        padding: 40px 0px 40px 40px;
                        width: 75%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    imageStyles: {
        css: css`
            /* max-width: 554px; */
            width: 100%;
            position: relative;
            height: 100%;
            object-fit: contain;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 330px;
                        top: 7px;
                    `,
                    css`
                        max-width: 330px;
                        top: 7px;
                    `,
                    css`
                        /* max-width: 300px; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mainUserNameTitleStyles: {
        css: css`
            font-size: ${TYPOGRAPHY.size.xxlarge};
            font-weight: ${TYPOGRAPHY.weight.bold};
            line-height: 40px;
            color: white;
            overflow-wrap: anywhere;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                    `,
                    css`
                        text-align: center;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    loggedOutTitleStyles: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: ${TYPOGRAPHY.size.xxlarge};
            font-weight: ${TYPOGRAPHY.weight.bold};
            line-height: 40px;
            color: ${COLORS.white};
        `,
    },
    mainTitleStyles: {
        css: css`
            font-size: 56px;
            font-weight: 800;
            line-height: 64px;
            color: white;
            overflow-wrap: anywhere;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                        font-size: ${TYPOGRAPHY.size.xxlarge};
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        line-height: 40px;
                    `,
                    css`
                        text-align: center;
                        font-size: ${TYPOGRAPHY.size.xxlarge};
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        line-height: 40px;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    searchbarStyles: {
        css: css`
            width: 100%;
            margin: 24px 0px 40px 0px;
            .popover {
                width: 78vw !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 90vw !important;
                        `,
                        css`
                            width: 90vw !important;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            > div[class^="OverflowWrapper"] {
                > div[class^="sc"] {
                    padding: 0px !important;
                    > ${FormFieldStyle} {
                        > ${FormInputWrapper} {
                            > ${InputStyle} {
                                box-shadow: none;
                                border: none !important;
                            }
                        }
                    }
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    buttonMainContainer: {
        css: css`
            display: flex;
            > div:nth-child(2) {
                margin-left: 24px;
            }
        `,
    },

    btnstyles: {
        css: css`
            margin-right: 8px;
            > span {
                font-size: ${TYPOGRAPHY.size.large};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                line-height: 24px;
                color: white !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: ${TYPOGRAPHY.size.base};
                        `,
                        css``,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
    btnChildContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            align-items: center;
        `,
    },
};

const styles = cenNewHomepageBannerStyles;
const CENNewHomepageTopBanner: FC<Props> = ({ fields, id, session }) => {
    const loginUrl = useGetLink(fields.bannerLoginbtnLink);
    const createAccountUrl = useGetLink(fields.bannerCreateAccountbtnLink);

    const loggedInUserName = session.userName;
    const [leftDivHeight, setLeftDivHeight] = useState<number | undefined>(undefined);

    useEffect(() => {
        const handleResize = () => {
            const leftContentDiv = document.getElementById("leftContentDiv");
            if (leftContentDiv) {
                const height = leftContentDiv.getBoundingClientRect().height;
                setLeftDivHeight(height);
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const isLoggedIn = (session.isAuthenticated || session.rememberMe) && !session.isGuest;

    const rightImgDiv: any = {
        css: css`
            height: ${leftDivHeight}px;
            width: 41.67%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                        width: 100%;
                    `,
                    css`
                        height: auto;
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    };
    return (
        <StyledWrapper {...styles.mainBannerBackgroundContainer}>
            <StyledWrapper {...styles.bannerContainer}>
                <StyledWrapper {...styles.bannerContentContainer} id="leftContentDiv">
                    {isLoggedIn && loggedInUserName.length > 0 ? (
                        <>
                            <Typography as="h2" {...styles.mainTitleStyles}>
                                {fields.loginTitle}
                            </Typography>
                            <Typography as="h2" {...styles.mainUserNameTitleStyles}>
                                {loggedInUserName}
                            </Typography>
                        </>
                    ) : (
                        <Typography as="h2" {...styles.loggedOutTitleStyles}>
                            {fields.bannerTitle}
                        </Typography>
                    )}

                    <StyledWrapper {...styles.searchbarStyles}>
                        <SearchInput id={id} />
                    </StyledWrapper>

                    {!isLoggedIn && (
                        <StyledWrapper {...styles.buttonMainContainer}>
                            <StyledWrapper {...styles.btnChildContainer}>
                                <Link href={loginUrl.url} {...styles.btnstyles}>
                                    {fields.bannerLoginbtnLabel}
                                </Link>
                                <Icon src={ArrowRightWhiteIcon} />
                            </StyledWrapper>
                            <StyledWrapper {...styles.btnChildContainer}>
                                <Link href={createAccountUrl.url} {...styles.btnstyles}>
                                    {fields.bannerCreateAccountbtnLabel}
                                </Link>
                                <Icon src={ArrowRightWhiteIcon} />
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                <StyledWrapper {...rightImgDiv}>
                    <Img src={fields.bannerImage} altText={fields.bannerTitle} {...styles.imageStyles} />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const CenNewHomePageTopBanner: WidgetModule = {
    component: connect(mapStateToProps)(CENNewHomepageTopBanner),
    definition: {
        group: "Common",
        displayName: "CEN New HomePage Banner",
        fieldDefinitions: [
            {
                name: fields.loginTitle,
                editorTemplate: "TextField",
                displayName: "Logged In Title",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerTitle,
                editorTemplate: "MultilineTextField",
                displayName: "Logged Out Title",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerImage,
                editorTemplate: "ImagePickerField",
                displayName: "Banner Image",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerLoginbtnLabel,
                editorTemplate: "TextField",
                displayName: "Primary Button Label",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerCreateAccountbtnLabel,
                editorTemplate: "TextField",
                displayName: "Secondary Button Label",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerLoginbtnLink,
                displayName: "Primary Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
            },
            {
                name: fields.bannerCreateAccountbtnLink,
                displayName: "Secondary Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
            },
        ],
    },
};
export default CenNewHomePageTopBanner;
